<template>
  <div >

    <table class="table table-responsive">
      <thead >
        <tr>
          <th scope="col">Location</th>
          <th scope="col">Time</th>
          <th scope="col">Predicted Winner</th>
          <th scope="col">Odds</th>
          <th scope="col">Actual Winner</th>
          <th scope="col">Diff</th>
          <th scope="col">Predicted Winner Min Skill</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="race in races" class="clickable" @click="showRaceDetail(race)">
          <td >{{race.location}}</td>
          <td >{{race.time}}</td>
          <td>{{race.skillWinner}}</td>
          <td>{{race.skillWinnerOdds? race.skillWinnerOdds.toFixed(2): '-'}}</td>
          <td>{{race.actualWinner}}</td>
          <td>{{(race.horses[0].skill - race.horses[1].skill).toFixed(2)}}</td>
          <td>{{getMinSkillWinner(race).name}}</td>
        </tr>
      </tbody>
    </table>

  </div>
</template>

<script>
export default {
  name: 'PredictionTablev2',
  props:   {
    races: Array,
    reloadCount: 0
  },
  components: {
  },
  data () {
    return {
      title: 'PredictionTablev2',
    }
  },
  watch: {
  },
  methods: {
    showRaceDetail: function(race) {
      this.$emit('raceSelected', race)
    },
    getMinSkillWinner: function (race) {
      let horsesSortedByMinSkill = [...race.horses].sort((a,b) => b.skillObj && a.skillObj? b.skillObj.minSkill - a.skillObj.minSkill: 0)
      return horsesSortedByMinSkill[0]
    }
  },
  mounted () {

  }
}

function average(array) {
  if (array) {
    const sum = array.reduce((a, b) => a + b, 0);
    return (sum / array.length) || 0;
  }else {
    return 0
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
#nameCell {
  font-size: 10pt
}

.green {
  background-color: green
}
</style>
